export { Avatar } from './Avatar'
export type {
  AvatarIconProps,
  AvatarPortraitProps,
  AvatarProps,
} from './Avatar.types'
